<template>
  <MongoDataTable
    ref="table"
    :headers="new Array(5).fill({})"
    itemKey="key"
    :dataTableProps="{ expand: true }"
    :insertable="false"
    :editable="false"
    :deletable="false"
    :selectable="false"
    :refreshable="false"
    :filterable="false"
    :columnSelectable="true"
    :sortable="false"
    :rowsPerPage="-1"
    :countable="false"
    containerClass="elevation-0"
    :hideToolbar="true"
    :hideHeaders="false"
    :hideFooters="false"
    :onTableItems="v => v"
    :onRefresh="() => {}"
  >
    <template slot="headers" slot-scope="props">
      <tr>
        <th class="column text-xs-center" width="100" @click="changeSort('accountId')">
          <div>Account Id</div>
        </th>
        <th class="column text-xs-center" width="100" @click="changeSort('exchange')">
          <div>Exchange</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('client')">
          <div>Client</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('exchangeUsername')">
          <div>Exchange Username</div>
        </th>
        <th class="column text-xs-left" width="100" @click="changeSort('bot_roles')">
          <div>Report Role</div>
        </th>
        <th class="column text-xs-left" width="100">
          <div>Bots</div>
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr class="disable-hover-color cursor-pointer">
        <td>
          {{props.scope.item.accountId}}
        </td>
        <td>
          {{props.scope.item.exchange}}
        </td>
        <td>
          {{props.scope.item.client}}
        </td>
        <td>
          {{props.scope.item.exchangeUsername}}
        </td>
        <td>
          {{props.scope.item.bot_roles}}
        </td>
        <td>
          {{props.scope.item.bots.join(', ')}}
        </td>
      </tr>
    </template>
  </MongoDataTable>
</template>

<script>
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable'
import MongoDataTableItemField from '../../components/mongo-datatable/MongoDataTableItemField'
import { titleText } from '../../libs/utils'

export default {
  props: {
    ready: { type: Boolean, required: false, default: true },
    loading: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
    items: { type: Array, required: true }
  },
  components: {
    MongoDataTable,
    MongoDataTableItemField
  },
  watch: {
    loading: {
      immediate: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    },
    items: {
      deep: true,
      handler (val) {
        this.$nextTick(async () => {
          await this.refresh()
        })
      }
    }
  },
  methods: {
    titleText,
    async refresh () {
      const table = this.$refs.table
      table.setLoader(this.loading)
      if (!this.loading) {
        table.setItems(this.items, true)
      }
    },
    async toggleCheckAllBots(select) {
      this.items.map(c => c.select = select)
      this.refresh()
    },
    changeSort (column) {
      this.$refs.table.changeSort(column)
    }
  }
}
</script>
